export function inputFile() {
    $("input[type='file']").parents(".form-field").addClass("fileupload-parent");
    $("input[type='file']").wrap(`
        <div class="file-field-box">
            <label>
                <span>
                    Select File
                </span>
            </label>
            <div class="file-field-box-name">No file chosen</div>
        </div>
        `);
    $("input[type='file']").on("change", function () {
        let _this = $(this);
        let fileName = _this.val().split("/").pop().split("\\").pop();
        _this.parents(".file-field-box").find(".file-field-box-name").html(fileName);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/inputFile.js